import { Chip } from "../widgets/utils";
import { useState } from "react";

export const DestinationCard = ({ destination, onClick }: any) => {
    const d = destination;
    const [imgLoaded, setImgLoaded] = useState(false);

    return (
      <div
        className={'card destination' + (imgLoaded ? '' : ' card-img1-loading')}
        onClick={() => onClick(d)}
      >
        <Chip>{d.name}</Chip>
        <img
          src={d.photo}
          alt={""}
          loading="lazy"
          style={{ opacity: imgLoaded ? 1 : 0 }}
          onLoad={() => setImgLoaded(true)}
        />
      </div>
    )
  }
